import React, { FC } from 'react';
import { InformationTextCont } from './InformationText.styles';

interface IInformationText {
  text: string;
  className?: string;
}

const InformationText: FC<IInformationText> = ({ text }) => {
  return <InformationTextCont data-testid="informationText">{text}</InformationTextCont>;
};

export default InformationText;
